import { Card, CardBody, Col, Table } from 'reactstrap'
import GridOptionTableHead from './GridOptionTableHead'
import GridOptionTableBody from './GridOptionTableBody'
import { GridOptions } from '../../../../utils/Constant'
import { gridData } from '../../../../Data/Ui-Kits/Grid/GridData'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const GridOptionsCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={GridOptions} span={gridData} />
        <CardBody>
          <div className="custom-scrollbar grid-table">
            <Table bordered striped responsive>
              <GridOptionTableHead />
              <GridOptionTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default GridOptionsCart